module.exports = __webpack_public_path__ + "img/oneOrange.bece9b00.jpg";